import { render, staticRenderFns } from "./ConnectBlock.vue?vue&type=template&id=543ea075&scoped=true"
import script from "./ConnectBlock.vue?vue&type=script&lang=ts"
export * from "./ConnectBlock.vue?vue&type=script&lang=ts"
import style0 from "./ConnectBlock.vue?vue&type=style&index=0&id=543ea075&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543ea075",
  null
  
)

export default component.exports